import {useSelector} from 'react-redux';


import cartService from '../../../../services/CartService';

import {cartSelectors} from '../index';


/**
 * Checks if the cart exists AND is not outdated
 *
 * @param cartId {string} Cart id to check loaded state
 * @return {boolean} True if loaded and not outdated; false otherwise
 */
function useIsCartLoaded(cartId) {

    const isCartLoaded = useSelector(state => cartSelectors.isCartLoaded(state, cartId));
    let cart = useSelector(state => cartSelectors.getCart(state, cartId));

    return isCartLoaded && !cartService.isCartOutdated(cart);
}


export default useIsCartLoaded;
